import { render, staticRenderFns } from "./dialogueList.vue?vue&type=template&id=557584d6&scoped=true"
import script from "./dialogueList.vue?vue&type=script&lang=js"
export * from "./dialogueList.vue?vue&type=script&lang=js"
import style0 from "./dialogueList.vue?vue&type=style&index=0&id=557584d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557584d6",
  null
  
)

export default component.exports